import { render, staticRenderFns } from "./kia.vue?vue&type=template&id=62a51c6e&scoped=true"
import script from "./kia.vue?vue&type=script&lang=js"
export * from "./kia.vue?vue&type=script&lang=js"
import style0 from "./kia.vue?vue&type=style&index=0&id=62a51c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a51c6e",
  null
  
)

export default component.exports